import { useEffect, useState } from "react";

import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";

import { TextUtils } from "../../../utils";

export type CountdownProps = {
  seconds: number;
  loop?: boolean;
  onFinish?: () => void;
};

export function Countdown(props: CountdownProps) {
  const { seconds, loop, onFinish } = props;

  const [remaining, setRemaining] = useState(seconds);

  useEffect(() => {
    const interval = setInterval(() => {
      const newRemaining = remaining - 1;
      if (newRemaining === -1) {
        onFinish?.();
        if (loop) setRemaining(seconds);
        else clearInterval(interval);
      } else {
        setRemaining(newRemaining);
      }
    }, 1_000);
    return () => clearInterval(interval);
  }, [remaining, loop, seconds, onFinish]);

  return (
    <Box position="relative">
      <CircularProgress variant="indeterminate" size={128} thickness={4} />
      <Box
        style={{ inset: 0 }}
        position="absolute"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <Typography variant="h5">{remaining}</Typography>
        <Typography variant="body2">
          {TextUtils.plural(remaining, "second")}
        </Typography>
      </Box>
    </Box>
  );
}
